class Toggler{

    constructor(el, options = {}) {
        this.el = document.querySelectorAll(el);
        this.options = options;
        if (this.el.length > 0) {
            this.setupEvents();
        }
    }
    
    setupEvents() {
        const that = this;
        this.el.forEach(item => {
            item.addEventListener('click', (e) => {
                document.body.classList.toggle(item.dataset.toggle);
            });
            
            if (that.options.resize) {
                window.addEventListener('resize', () => {
                    document.body.classList.remove(item.dataset.toggle);
                });   
            }
        })
    }
}
export default Toggler;